import React from "react";
import toast from "../../components/base/Toast";
import moment from "moment";

// Page Coponents
import PaymentFormFields from "./PaymentFormFields";

// Components
import Form from "../../components/base/Form";
import CancelButton from "../../components/base/CancelButton";
import SaveButton from "../../components/base/SaveButton";

// Configs
import { endpoints } from "../../configs";

// API call
import { apiClient } from "../../apiClient";
import { isBadRequest } from "../../common/http";

export default class AddPaymentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: null
    };

    this.handleChange = this.handleChange.bind(this);
  }

  // Handle date
  handleChange(date) {
    this.setState({
      date: date
    });
  }

  // Create payment
  _submit = values => {
    if (this._validateFields(values) === false) {
      return;
    }

    // Save Payment form in the final
    this._createPayment(this._toArray(values));
  };

  // Validate Fields
  _validateFields(values) {
    let success = true;
    return success;
  }

  // To Array
  _toArray(values) {
    values.date = this.state.date
      ? moment(this.state.date).format("YYYY-MM-DD")
      : null;
    return values;
  }

  // Payment API Call
  _createPayment(data) {
    return apiClient
      .post(endpoints().paymentAPI, data)
      .then(() => {
        window.location.replace("/payment");
      })
      .catch(error => {
        if (isBadRequest(error)) {
          let errorMessage;
          const errorRequest = error.response.request;
          if (errorRequest && errorRequest.response) {
            errorMessage = JSON.parse(errorRequest.response).message;
          }
          toast.error(error.response.data.message);
          console.error(errorMessage);
        }
      });
  }

  render() {
    const initialValues = {
      date: ""
    };

    return (
      <Form
        initialValues={initialValues}
        onSubmit={values => {
          this._submit(values);
        }}
      >
        <PaymentFormFields
          handleChange={this.handleChange}
          date={this.state.date}
        />
        <div className="d-flex justify-content-end">
          <CancelButton onClick={() => this.props.history.goBack()} />
          <SaveButton />
        </div>
      </Form>
    );
  }
}
